import * as CONSTANTS from 'store/constants/payments'

const initialState = {
  clientSecretIsLoading: false,
  clientPaymentSecretKey: '',
  cardsAreLoading: false,
  userCards: [],
  cardsAreSaving: false,
  bankAccountSetupIntentIsLoading: false,
  bankAccountSetupIntent: {},
  bankAccountsAreLoading: false,
  bankAccounts: [],
  bankAccountsAreSaving: false,
}

const payments = (state = initialState, action = {}) => {
  switch (action.type) {
    case CONSTANTS.GET_CLIENT_PAYMENT_SECRET_START:
      return {
        ...state,
        clientSecretIsLoading: true,
      }
    case CONSTANTS.GET_CLIENT_PAYMENT_SECRET_END:
      return {
        ...state,
        clientSecretIsLoading: false,
        clientPaymentSecretKey: action.payload,
      }
    case CONSTANTS.GET_USER_CARDS_START:
      return {
        ...state,
        cardsAreLoading: true,
      }
    case CONSTANTS.GET_USER_CARDS_END:
      return {
        ...state,
        cardsAreLoading: false,
        userCards: action.payload,
      }
    case CONSTANTS.SAVE_USER_CARD_START:
      return {
        ...state,
        cardsAreSaving: true,
      }
    case CONSTANTS.SAVE_USER_CARD_END:
      return {
        ...state,
        cardsAreSaving: false,
      }
    case CONSTANTS.UPDATE_USER_CARD_START:
      return {
        ...state,
        cardsAreSaving: false,
      }
    case CONSTANTS.UPDATE_USER_CARD_END:
      return {
        ...state,
        cardsAreSaving: true,
      }
    case CONSTANTS.DELETE_USER_CARD_START:
      return {
        ...state,
        cardsAreSaving: false,
      }
    case CONSTANTS.DELETE_USER_CARD_END:
      return {
        ...state,
        cardsAreSaving: true,
      }
    case CONSTANTS.GET_USER_CARD_START:
      return {
        ...state,
        cardsAreSaving: false,
      }
    case CONSTANTS.GET_USER_CARD_END:
      return {
        ...state,
        cardsAreSaving: true,
      }
    // Bank Account Setup Intent
    case CONSTANTS.GET_BANK_ACCOUNT_SETUP_INTENT_START:
      return {
        ...state,
        bankAccountSetupIntentIsLoading: true,
      }
    case CONSTANTS.GET_BANK_ACCOUNT_SETUP_INTENT_END:
      return {
        ...state,
        bankAccountSetupIntentIsLoading: false,
        bankAccountSetupIntent: action.payload,
      }
    // Bank Accounts
    case CONSTANTS.GET_BANK_ACCOUNTS_START:
      return {
        ...state,
        bankAccountsAreLoading: true,
      }
    case CONSTANTS.GET_BANK_ACCOUNTS_END:
      return {
        ...state,
        bankAccountsAreLoading: false,
        bankAccounts: action.payload,
      }
    case CONSTANTS.SAVE_BANK_ACCOUNT_START:
      return {
        ...state,
        bankAccountsAreSaving: true,
      }
    case CONSTANTS.SAVE_BANK_ACCOUNT_END:
      return {
        ...state,
        bankAccountsAreSaving: false,
      }
    case CONSTANTS.UPDATE_BANK_ACCOUNT_START:
      return {
        ...state,
        bankAccountsAreSaving: true,
      }
    case CONSTANTS.UPDATE_BANK_ACCOUNT_END:
      return {
        ...state,
        bankAccountsAreSaving: false,
      }
    case CONSTANTS.DELETE_BANK_ACCOUNT_START:
      return {
        ...state,
        bankAccountsAreSaving: true,
      }
    case CONSTANTS.DELETE_BANK_ACCOUNT_END:
      return {
        ...state,
        bankAccountsAreSaving: false,
      }
    case CONSTANTS.SET_BANK_ACCOUNT_DEFAULT_START:
      return {
        ...state,
        bankAccountsAreSaving: true,
      }
    case CONSTANTS.SET_BANK_ACCOUNT_DEFAULT_END:
      return {
        ...state,
        bankAccountsAreSaving: false,
      }
    default:
      return state
  }
}

export default payments
